import Ingredient from './Ingredient';
export default Ingredient;
